import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { routes } from './app/routes';
// import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
// import { getAuth, provideAuth } from '@angular/fire/auth';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { IonicModule } from '@ionic/angular';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
// import * as Sentry from '@sentry/capacitor';
// import { init as sentryAngularInit } from '@sentry/angular';
import { register } from 'swiper/element/bundle';
import { MainInterceptor } from './app/core/main.interceptor';
import localeDe from '@angular/common/locales/de';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeDe);
registerLocaleData(localeFr);
register();

if (environment.production) {
	enableProdMode();
}

const socketConfig: SocketIoConfig = {
	url: environment.baseUrl,
	options: {
		path: '/v1/socketio/socket.io/',
	},
};

// Sentry.init(
// 	{
// 		dsn: 'https://e1dbd73b1cd9e1083c9875f1b55842be@logs.smoothr.de/12',
// 		integrations: [
// 			Sentry.browserTracingIntegration(),
// 			Sentry.replayIntegration({
// 				maskAllInputs: true,
// 				stickySession: true,
// 				blockAllMedia: true,
// 				mutationLimit: 200,
// 				mutationBreadcrumbLimit: 100,
// 			}),
// 		],
// 		tracesSampleRate: 0.1,
// 		profilesSampleRate: 0.1,
// 		replaysSessionSampleRate: 0.1,
// 		replaysOnErrorSampleRate: 0.1,
// 		maxBreadcrumbs: 30,
// 		beforeBreadcrumb(breadcrumb) {
// 			if (breadcrumb.level !== 'fatal' && breadcrumb.level !== 'error' && breadcrumb.level !== 'info') {
// 				return null;
// 			}
// 			return breadcrumb;
// 		},
// 		environment: environment.production ? 'production' : 'development',
// 		beforeSend(event, hint) {
// 			const error = hint.originalException;
//
// 			// Filter out expected client errors (4xx) and network errors that are already handled
// 			if (error && typeof error === 'object' && 'response' in error) {
// 				const axiosError = error as any;
// 				const status = axiosError.response?.status;
// 				const url = axiosError.config?.url || '';
//
// 				// Ignore expected errors that are handled gracefully in the app:
// 				// - 404 for promo codes (user entered invalid code or no promo available)
// 				// - 404 for token refresh (user session expired - expected)
// 				// - 401 for customer endpoints (user not logged in)
// 				// - 422 for payment/registration (validation errors - shown to user)
// 				// - 400 for cart recommendations (endpoint may not exist in all environments)
// 				if (
// 					(status === 404 && (url.includes('promoCode') || url.includes('token/refresh'))) ||
// 					(status === 401 && url.includes('/customer/')) ||
// 					(status === 422 && (url.includes('/payment/') || url.includes('/auth/register'))) ||
// 					(status === 400 && url.includes('cartrecommendation'))
// 				) {
// 					return null;
// 				}
// 			}
//
// 			// Filter out network timeouts and NO_RESPONSE errors (temporary network issues)
// 			if (error && typeof error === 'object' && 'config' in error) {
// 				const axiosError = error as any;
// 				const url = axiosError.config?.url || '';
// 				// NO_RESPONSE typically means network timeout or server unavailable
// 				if (url.includes('/order/slot/') && !axiosError.response) {
// 					return null;
// 				}
// 			}
//
// 			// Filter out OutOfMemoryError and Capacitor bridge errors (device limitations, not app bugs)
// 			const errorMessage = event.exception?.values?.[0]?.value || '';
// 			if (
// 				errorMessage.includes('OutOfMemoryError') ||
// 				errorMessage.includes('Failed to allocate') ||
// 				errorMessage.includes('Error invoking postMessage')
// 			) {
// 				return null;
// 			}
//
// 			// Filter out Firebase Authentication normal states (not errors)
// 			// "No user is signed in" is a completely normal state, not an error
// 			if (errorMessage.includes('No user is signed in') || errorMessage.includes('AUTHENTICATION_FAILED')) {
// 				return null;
// 			}
//
// 			// Filter out Keyboard plugin unimplemented methods (Ionic internal calls)
// 			if (errorMessage.includes('Keyboard') && errorMessage.includes('UNIMPLEMENTED')) {
// 				return null;
// 			}
//
// 			// Filter API interceptor errors (same patterns as above but in message format)
// 			// API interceptor creates errors like: "POST /v1/general/promoCode/code → 404"
// 			if (
// 				(errorMessage.includes('promoCode') && errorMessage.includes('→ 404')) ||
// 				(errorMessage.includes('token/refresh') && errorMessage.includes('→ 404')) ||
// 				(errorMessage.includes('/payment/') && errorMessage.includes('→ 422')) ||
// 				(errorMessage.includes('/auth/register') && errorMessage.includes('→ 422'))
// 			) {
// 				return null;
// 			}
//
// 			return event;
// 		},
// 	},
// 	sentryAngularInit
// );

bootstrapApplication(AppComponent, {
	providers: [
		provideZoneChangeDetection(),
		provideRouter(routes),
		// provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
		// provideAuth(() => getAuth()),
		importProvidersFrom(IonicModule.forRoot()),
		importProvidersFrom(SocketIoModule.forRoot(socketConfig)),
		provideHttpClient(withInterceptorsFromDi()),
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MainInterceptor,
			multi: true,
		},
		provideIonicAngular({
			spinner: 'crescent',
			swipeBackEnabled: false,
			scrollAssist: false,
			mode: 'md',
		}),
		provideTranslateService({
			lang: 'en',
			fallbackLang: 'en',
			loader: provideTranslateHttpLoader({
				prefix: '/assets/i18n/',
				suffix: '.json',
			}),
		}),
	],
});
